import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SafeAny } from '../../../types/safe-any';

@Component({
  selector: 'ciwc-quote-total-tabs',
  templateUrl: './quote-total-tabs.component.html',
  styleUrls: ['./quote-total-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe, DecimalPipe],
})
export class QuoteTotalTabsComponent {
  @Input() tabs: SafeAny = [];
}
